import React from "react";
import { Icon } from "@iconify/react";

const ChallengeArenaIcon = () => (
  <Icon icon="lucide:trophy" width={18} height={18} />
);

export default ChallengeArenaIcon;
